import ServiciosDelAPI from "servicios/ServiciosDelAPI";

export const setearDatosAlStore = ({dispatchAction, data}) => async (dispatch) => {
    dispatch({type: dispatchAction, payload: data})
    return data;
}

export const obtenerDepartamentosPersonalizado = ({controller, validateIfDataExists = false, stateInStore, saveInStore = true, dispatchAction, action = 'listar'}) => async (dispatch) => {
    try {

        // validating if you want to validate if the data exists in store then validate that the data is greater than 0
        if(validateIfDataExists && stateInStore.length > 0) return {data: stateInStore, error: null};

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error };

        const response = await ServiciosDelAPI[controller].obtenerRegistros();

        let newData = [];
        // to remove items you won't use
        response.data.forEach( item => { if(item.id !== 24 && item.id !== 25) newData.push(item) });

        if(response.error) return {error: response.error}

        // Valitatinf if you want to save in store the response
        if(saveInStore) dispatch({ type: dispatchAction, payload: newData});

        // return the response if you want to manipulate this response.
        return {data: newData};
    } catch (error) {
        return error
    }
}

export const obtenerMunicipiosPersonalizado =  ({controller, stateInStore, dispatchAction, departamentoID}) => async (dispatch) => {
    try {

        if(stateInStore && stateInStore.length > 0) {
            const currentMunicipality = stateInStore?.filter( ({departamento_id}) => Number(departamento_id) === Number(departamentoID));
            if(currentMunicipality?.length > 0) return {data: currentMunicipality, error: null};
        };

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, 'listar');

        if(hasPermission.error) return {error: hasPermission.error };

        const response = await ServiciosDelAPI[controller].obtenerRegistrosConParametros();

        if(response.error) return {error: response.error}

        dispatch({ type: dispatchAction, payload: response?.data});

        return response;
    } catch (error) {
        return error
    }
}

// SIRVE PARA OBTENER LOS REGISTROS SI TIENE O NO PARAMETROS DE BUSQUEDA
export const obtenerRegistrosPersonalizado = ({controller, validateIfDataExists = false, stateInStore, saveInStore = true, dispatchAction, action = 'listar', nombreDelMetodo = null, tieneParametros = true}) => async (dispatch) => {
    try {
        // validating if you want to validate if the data exists in store then validate that the data is greater than 0
        if(validateIfDataExists && stateInStore.length > 0) return {data: stateInStore, error: null};

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error };

        let response = {};
        if(tieneParametros) response = await ServiciosDelAPI[controller].obtenerRegistrosConParametros(nombreDelMetodo);
        else response = await ServiciosDelAPI[controller].obtenerRegistros();

        if(response.error) return {error: response.error}

        // Valitatin if you want to save in store the response
        if(saveInStore) dispatch({ type: dispatchAction, payload: response?.data})

        // return the response if you want to manipulate this response.
        return response;
    } catch (error) {
        return error
    }
}

// SIRVE PARA OBTENER LOS REGISTROS SI TIENE O NO PARAMETROS DE BUSQUEDA
export const obtenerRegistrosPorURL = ({controller, validateIfDataExists = false, stateInStore, saveInStore = true, dispatchAction, action = 'listar', nombreDelMetodo = null, parametro}) => async (dispatch) => {
    try {
        // validating if you want to validate if the data exists in store then validate that the data is greater than 0
        if(validateIfDataExists && stateInStore.length > 0) return {data: stateInStore, error: null};

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error };

        const response = await ServiciosDelAPI[controller].obtenerRegistrosPorURL(nombreDelMetodo, parametro);

        if(response.error) return {error: response.error}

        // Valitatin if you want to save in store the response
        if(saveInStore) dispatch({ type: dispatchAction, payload: response?.data})

        // return the response if you want to manipulate this response.
        return response;
    } catch (error) {
        return error
    }
}

// SIRVE PARA NUEVO O ACTUALIZAR REGISTROS
export const nuevoOActualizarRegistroPersonalizado = ({controller, action, data, nombreDelMetodo = null}) => async () => {
    try {

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error};

        let response = {};
        if(action === 'crear') response = await ServiciosDelAPI[controller].nuevoRegistro(nombreDelMetodo, data);
        else response = await ServiciosDelAPI[controller].actualizarRegistro(nombreDelMetodo, data);

        if(response.error) return {error: response.error}

        return response;

    } catch (error){
        return error
    }
}

export const nuevoOActualizarRegistroPersonalizadoConMetodo = ({controller, action, data, nombreDelMetodo = null}) => async () => {
    try {

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error};

        let response = {};
        if(action) response = await ServiciosDelAPI[controller].nuevoRegistro(nombreDelMetodo, data);
        else response = await ServiciosDelAPI[controller].actualizarRegistro(nombreDelMetodo, data);

        if(response.error) return {error: response.error}

        return response;

    } catch (error){
        return error
    }
}

export const nuevoOActualizarRegistroSinPermiso = ({controller, action, data, nombreDelMetodo = null}) => async () => {
    try {

        let response = {};
        if(action === 'crear') response = await ServiciosDelAPI[controller].nuevoRegistro(nombreDelMetodo, data);
        else response = await ServiciosDelAPI[controller].actualizarRegistro(nombreDelMetodo, data);

        if(response.error) return {error: response.error}

        return response;

    } catch (error){
        return error
    }
}

// SIRVE PARA ACTUALIZAR REGISTROS CON METODO PATCH
export const registroPatchPersonalizado = ({controller, action, data}) => async () => {
    try {

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error };

        const response = await ServiciosDelAPI[controller].patchPersonalizado(action, data);

        if(response.error) return {error: response.error}

        return response;

    } catch (error){
        return error
    }
}

// SIRVE PARA ACTUALIZAR REGISTROS CON 2 METODO UTILIZANDO PATCH
export const patchPersonalizadoConDosMetodos = ({controller, action, data, method, methodTwo, tipoMetodo }) => async () => {
    try {

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error };

        const response = await ServiciosDelAPI[controller].patchPersonalizadoConMetodos(action, method, methodTwo, data, tipoMetodo);

        if(response.error) return {error: response.error}

        return response;

    } catch (error){
        return error
    }
}

// SIRVE PARA OBTENER UN DOCUMENTO REGISTRADO
export const obtenerDocumentoPersonalizado = ({controller, validateIfDataExists = false, stateInStore, saveInStore = true, dispatchAction, action = 'openFile', documentName, idRegistro}) => async () => {
    try {

        if(validateIfDataExists && stateInStore.length > 0) return {data: stateInStore, error: null};

        const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller, action);

        if(hasPermission.error) return {error: hasPermission.error };

        const response = await ServiciosDelAPI[controller].getDocumentRegister(action, documentName, idRegistro);

        if(response.error) return {error: response.error}

        if(saveInStore)  dispatchAction(response?.data)

        return response;
    } catch (error) {
        return error
    }
}


export const obtenerRegistrosPersonalizadoPublic = ({controller, validateIfDataExists = false, stateInStore, saveInStore = true, dispatchAction, action = 'listar', nombreDelMetodo = null, tieneParametros = true}) => async (dispatch) => {
    try {

        let response = {};
        if(tieneParametros) response = await ServiciosDelAPI[controller].obtenerRegistrosConParametros(nombreDelMetodo);
        else response = await ServiciosDelAPI[controller].obtenerRegistros();

        if(response.error) return {error: response.error}

        // Valitatin if you want to save in store the response
        if(saveInStore) dispatch({ type: dispatchAction, payload: response?.data})

        // return the response if you want to manipulate this response.
        return response;
    } catch (error) {
        return error
    }
}

export const obtenerInformacionPublica = ({controller, action}) => async () => {
    try {

        const response = await ServiciosDelAPI[controller].customGETpublic(action);

        if(response.error) return {error: response.error, type: 2 }

        return response;
    } catch (error) {
        return error
    }
}